import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';

import { AfterRatingWindow } from '../../../components/afterRatingWindow';
import { ChatContainerInner } from '../../../components/chat';
import { ChatHeader } from '../../../components/chat/chatHeader';
import { ChatContentContainer } from '../../../components/layout/chatContentContainer';
import { HeaderContainer } from '../../../components/layout/headerContainer';
import { PrechatHeader } from '../../../components/prechat/prechatHeader';
import { Rating } from '../../../components/rating';
import { useSDK } from '../../index';

let firstTime = true;

const Chat = observer((): ReactElement => {
	const { conversationsStore, uiStateStore } = useSDK();
	useEffect(() => {
		if (!conversationsStore.isLatestConversationResolved) {
			firstTime = false;
		}
	}, [conversationsStore.isLatestConversationResolved]);

	return (
		<>
			<HeaderContainer>
				{!conversationsStore.isLatestConversationResolved || !firstTime ? <ChatHeader /> : <PrechatHeader />}
			</HeaderContainer>
			<ChatContentContainer>
				<ChatContainerInner />
			</ChatContentContainer>
			{uiStateStore.showRating && <Rating />}
			{uiStateStore.showAfterRatingWindow && <AfterRatingWindow />}
		</>
	);
});

export { Chat };
